import React from 'react'

import { Header } from './components'

import { Routes } from './routes'

export default function AppContent(): React.ReactElement {
	return (
		<div className="app">
			<header>
				<Header></Header>
			</header>
			<article>
				<Routes></Routes>
			</article>
		</div>
	)
}
